import { createFileRoute } from '@tanstack/react-router'

import { NnppImportSummaryPage } from '@/src/pages/nnpp/imports/NnppImportSummaryPage'

export const Route = createFileRoute(
  '/nnpp/imports/$importId/documents/$documentId/summary'
)({
  component: NnppImportSummaryPage,
  staticData: { layout: { enableScrolling: true, showSearchBar: false } },
})
